export default "__VITE_ASSET__88e2f3f1__"